import React from 'react';
import { Shield } from 'lucide-react';

const RiskManagementTab = () => {
  return (
    <div className="p-8 text-center">
      <Shield className="w-16 h-16 text-blue-500 mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-gray-800 mb-2">Risk Management</h3>
      <p className="text-gray-600">Risk assessment and management tools.</p>
    </div>
  );
};

export default RiskManagementTab; 